// src/types/accessRequest.ts

export type IndustryOption =
  | "Artist"
  | "Athlete"
  | "Banking"
  | "Consulting"
  | "Crypto Enthusiasts"
  | "Economics"
  | "Hedge Funds/Asset Management"
  | "Investment Banking"
  | "Marketing"
  | "Research"
  | "Sales"
  | "Software Engineering"
  | "Others";

export interface AccessRequestFormData {
  fullName: string;
  email: string;
  company?: string;
  industry: IndustryOption | "";
  reason: string;
  phone?: string;
  agreedToTerms?: boolean;
}

export interface AccessRequestSubmission {
  full_name: string;
  email: string;
  company: string | null;
  industry: string;
  reason: string;
  phone: string | null;
  agreed_to_terms: boolean;
}

export interface AccessRequestResponse {
  success: boolean;
  message: string;
  requestId?: string;
}

export const INDUSTRY_OPTIONS: IndustryOption[] = [
  "Artist",
  "Athlete",
  "Banking",
  "Consulting",
  "Crypto Enthusiasts",
  "Economics",
  "Hedge Funds/Asset Management",
  "Investment Banking",
  "Marketing",
  "Research",
  "Sales",
  "Software Engineering",
  "Others",
];
